import cx from 'classnames';
import type { FunctionComponent } from 'react';

import * as styles from './AiLoadingGradient.module.less';

interface AiLoadingGradientProps {
  testId?: string;
  className?: string;
}

/**
 * A presentational component that renders a semi-transparent animated gradient.
 * The component only handles the visual gradient styles (animation, colors, opacity).
 * Layout and positioning should be controlled by the parent component via the className prop.
 */
export const AiLoadingGradient: FunctionComponent<AiLoadingGradientProps> = ({
  testId,
  className,
}) => {
  return (
    <div
      className={cx(styles.aiLoadingGradient, className)}
      data-testid={testId}
    />
  );
};
